import blocksDefinitions from '@/assets/blocks';
import { Sprite, Texture } from 'pixi.js';
import Block from '../actors/Block';
import state from '../state';
import ticker from '../ticker';
import vars from '../vars';

class Blocks {
  constructor(parent, player) {
    this.parent = parent;
    this.player = player;
    this.blocks = [];
    this.index = 1;

    this.sprite = new Sprite();
    const emptyTexture = Texture.EMPTY;
    this.container = new Sprite(emptyTexture);

    this.frameHandler = () => { this.frame(); };

    this.resize();
    this.sprite.addChild(this.container);
    this.parent.addChild(this.sprite);
  }

  resize() {
    this.container.width = vars.layout.FRAME_WIDTH;
    this.container.height = vars.layout.FRAME_HEIGHT;

    // Set the sprite poisition offset by the difference on top
    this.sprite.position.y = -vars.layout.FRAME_TOP_DIFFERENCE;
  }

  startSpawn() {
    ticker.add(this.frameHandler);
  }

  frame() {
    for (let i = this.blocks.length - 1; i >= 0; i -= 1) {
      const block = this.blocks[i];
      // Move all the blocks
      block.sprite.position.y -= ticker.speed * state.speed;
      // Delete if needed outside the view
      if (block.sprite.position.y < -vars.layout.GRID_UNIT * 10) { // Higher than 10 gu blocks will suddenly disappear
        block.destroy();
        this.blocks.splice(i, 1);
      }
    }

    const gap = vars.layout.GRID_UNIT;
    if (
      this.blocks.length === 0
      || this.lastBlock.sprite.position.y < vars.layout.FRAME_HEIGHT - this.lastBlock.container.height - gap
    ) {
      // The last block is fully in viewport add the next one
      this.spawnBlock(this.index % 2 === 0);
      this.index += 1;
    }
  }

  spawnBlock(isSpacing) {
    const descriptor = blocksDefinitions.getRandomBlock(state.level, isSpacing);
    const block = new Block(this.sprite, this.player, descriptor);
    this.blocks.push(block);
  }

  gameover() {
    ticker.remove(this.frameHandler);
    for (let i = this.blocks.length - 1; i >= 0; i -= 1) {
      const block = this.blocks[i];
      block.destroy();
      this.blocks.splice(i, 1);
    }
  }

  replay() {
    this.lastTime = ticker.totalTime;
    ticker.add(this.frameHandler);
  }

  get lastBlock() {
    return this.blocks[this.blocks.length - 1] || null;
  }
}

export default Blocks;
